import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import {saveAs} from 'file-saver';
import { FormControl } from '@angular/forms';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { Product } from 'src/app/models/contract-assignor';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';

@Component({
  selector: 'app-favorecido-consolidada',
  templateUrl: './favorecido-consolidada.component.html',
  styleUrls: ['./favorecido-consolidada.component.css']
})
export class FavorecidoConsolidadaComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private alertService: NewAlertService,
    private contractService: ContratoService,
    public datepipe: DatePipe
  ) { }

  public currentUser: Auth;
  public filtro = new FilterUseProducts(null,null,null,null,null,false);

  public favorecidos: any;
  public mes: any;
  public filtroOn: boolean = false;

  assignorContractList: CedenteContrato[];
  productList: Product[];

  //#region filter form
  public productsCtrl: FormControl = new FormControl();
  public agroupCtrl: FormControl = new FormControl();

  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  queryDate: Date;
  public productsFilterText: string;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";
  
  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.filtro.groupByMonth = false;    

    this.dataInicio.setDate(this.dataInicio.getDate()-90);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
    this.getContracts();
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getSummarizedUseProducts(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.favorecidos = response.result.summarizedUseProducts;
        this.mes = response.result.groupByMonth;
        this.totalItems = response.result.total;
        this.queryDate = new Date();
      }
    });
  }  
  
  getContracts(){
    this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.productList = response.result.filter(x => x.categoriaProduto != CategoriaProduto.Flex);
          if (this.productList.length <= 0 && this.productList.length <= 0) {
            this.alertService.error(response.message);
          }
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Erro ao carregar o filtro de produtos' + error);
      }
    );
  }

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter() {
    this.filtro.dateStart;
    this.filtro.dateEnd;
    this.filtro.productsId = this.productsCtrl.value;
    this.productsFilterText = '';
    this.filtro.productsId?.forEach((x, i)=> {
      this.productsFilterText += i==0 ?this.getProduct(x) : ', ' + this.getProduct(x);
    });

    if(this.agroupCtrl.value != null)
      this.filtro.groupByMonth = this.agroupCtrl.value;

    if(
      this.filtro.dateStart == null &&
      this.filtro.dateStart == null &&
      this.filtro.productsId == null &&
      this.filtro.groupByMonth == false
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }

  deleteFilter(){
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;
    this.dataMaxima = this.dataFim;
    this.filtro.productsId = null
    this.filtro.groupByMonth = false

    this.productsCtrl.setValue(null);;
    this.agroupCtrl.setValue(false);

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_utilizacao_consolidada_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Data','Produto','Valor'];
    ws.WorksheetRows = [];

    this.relatorioService.getSummarizedUseProducts(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.summarizedUseProducts;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(this.datepipe.transform(r.date, this.mes ? 'MM/yyyy' : 'dd/MM/yyyy'));
          lr.push(r.product);
          lr.push(r.value );
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        /*excelService.generateExcel('Extrato Portal Cedente', worksheets).csv
        .writeBuffer({ encoding: 'UTF-8', formatterOptions: { delimiter: ';' } }).then((data) => {
            const blob = new Blob(['\ufeff', data], { type: 'text/csv; charset=UTF-8,'  });
            saveAs(blob, ws.worksheetTitle + '.csv');
        });*/

        excelService.generateExcelReport('Relatório de utilização consolidada', worksheets,null).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
  }
  
  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_utilizacao_consolidada_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Data','Produto','Valor',''];
    pdfData.PdfRows = [];

    this.relatorioService.getSummarizedUseProducts(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.summarizedUseProducts;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(this.datepipe.transform(r.date, this.mes ? 'MM/yyyy' : 'dd/MM/yyyy'));
          lr.push(r.product);
          lr.push('R$');
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          pdfData.PdfRows.push(lr);
        });

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
        filter += this.filtro.productsId?.length > 0 ? ' - Produtos: ' + this.productsFilterText : ''

        //let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Relatório de utilização consolidada',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  getProduct(item){
    return this.productList.find(x => x.produtoId == item).descricaoProduto;
  }
}